import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DsStepComponent } from "./ds-step.component";

@NgModule({
  declarations: [DsStepComponent],
  imports: [CommonModule],
  exports: [DsStepComponent],
})
export class DsStepModule {}
